var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar },attrs:{"id":"wrapper"}},[(_vm.document)?_c('ReleasePopup',{attrs:{"show":_vm.showReleasePopupModal,"document":_vm.document},on:{"closeModalReleasePopup":_vm.closeModalReleasePopup}}):_vm._e(),_c('notifications'),_c('dashboard-navbar',{attrs:{"show":true}}),(_vm.load)?_c('div',{staticClass:"global-preloader",attrs:{"id":"preloader"}},[_c('div',{staticClass:"preloader-content"},[_c('img',{staticClass:"preloader-image",attrs:{"src":require("rhomtrip_assets/src/img/icons/rhomtrip-icon.gif"),"alt":"Loading..."}}),_c('div',{staticClass:"preloader-bar-container"},[_c('div',{staticClass:"preloader-bar",style:({ width: _vm.progressBarWidth + '%' })})]),_c('p',{staticClass:"preloader-text",attrs:{"data-aos":"fade"}},[_vm._v("Loading...")])])]):_vm._e(),_c('side-bar',[_c('template',{slot:"links"},[_c('img',{staticClass:"logo-icon",attrs:{"src":_vm.getLogo(),"alt":"Rhomtrip"}}),_c('div',{staticClass:"nav-item text-center d-lg-block d-md-none"},[_c('span',{staticClass:"icon-open-close",class:{
            'close-side': _vm.verticalSidebar == false,
            'open-side': _vm.verticalSidebar == true
          },on:{"click":_vm.openSidebar}},[_c('i',{class:{
              'flaticon-menu-3 ': _vm.verticalSidebar == false,
              'flaticon-menu-2': _vm.verticalSidebar == true
            }})])]),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Reservations',
          icon: 'flaticon-calendar',
          path: '/reservations'
        }}}):_vm._e(),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Customers',
          icon: 'flaticon-employees',
          path: '/customers'
        }}}):_vm._e(),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Destinations',
          icon: 'flaticon-pin',
          path: '/destinations'
        }}}):_vm._e(),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Areas',
          icon: 'flaticon-radar ',
          path: '/coverage-areas'
        }}}):_vm._e(),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Vehicles',
          icon: 'flaticon-car',
          path: '/vehicles'
        }}}):_vm._e(),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Rates',
          icon: 'flaticon-bold-list ',
          path: '/rates'
        }}}):_vm._e(),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Drivers',
          icon: 'flaticon-driver-license',
          path: '/drivers'
        }}}):_vm._e(),(
          _vm.sesion.role === 'admin' ||
            _vm.sesion.role === 'supplier' ||
            _vm.sesion.role === 'company'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Schedule',
          icon: 'flaticon-history',
          path: '/schedules'
        }}}):_vm._e(),(_vm.sesion.role === 'supplier' || _vm.sesion.role === 'company')?_c('sidebar-item',{attrs:{"link":{
          name: 'Users',
          icon: 'flaticon-costumer',
          path: '/users'
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-content"},[_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),_c('globalFooter',{staticClass:"global-foot"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }